import React from 'react';
import dayjs from 'dayjs';
import { Select, InputNumber, DatePicker } from 'antd';
import type { InternalMedicineData } from '../../hooks/useConsultationForm';

interface Props {
  internalMedicineData: InternalMedicineData;
  setInternalMedicineField: (section: keyof InternalMedicineData, field: string, value: any) => void;
}

const HBA1C_TARGET_OPTIONS = [
  { value: '<7%', label: '<7%' },
  { value: '<7.5%', label: '<7.5%' },
  { value: '<8%', label: '<8%' },
  { value: 'Individualizada', label: 'Individualizada' },
];

const LDL_TARGET_OPTIONS = [
  { value: '<70 mg/dL', label: '<70 mg/dL' },
  { value: '<100 mg/dL', label: '<100 mg/dL' },
  { value: '<130 mg/dL', label: '<130 mg/dL' },
  { value: '<160 mg/dL', label: '<160 mg/dL' },
];

const TreatmentPlan: React.FC<Props> = ({ internalMedicineData, setInternalMedicineField }) => {
  const tp = internalMedicineData.treatment_plan;
  const set = (field: string, value: any) => setInternalMedicineField('treatment_plan', field, value);

  return (
    <div className="card mb-3">
      <div className="card-body">
        <h5 className="card-title">Plan de Tratamiento</h5>
        <div className="row mt-3">
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Meta HbA1c</label>
              <Select
                className="w-100"
                value={tp.hba1c_target || undefined}
                onChange={(v) => set('hba1c_target', v)}
                placeholder="Seleccionar..."
                options={HBA1C_TARGET_OPTIONS}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Meta PAS (mmHg)</label>
              <InputNumber
                className="w-100"
                min={0}
                max={300}
                value={tp.sbp_target}
                onChange={(v) => set('sbp_target', v)}
                placeholder="mmHg"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Meta PAD (mmHg)</label>
              <InputNumber
                className="w-100"
                min={0}
                max={200}
                value={tp.dbp_target}
                onChange={(v) => set('dbp_target', v)}
                placeholder="mmHg"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Meta LDL</label>
              <Select
                className="w-100"
                value={tp.ldl_target || undefined}
                onChange={(v) => set('ldl_target', v)}
                placeholder="Seleccionar..."
                options={LDL_TARGET_OPTIONS}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Próxima Cita</label>
              <DatePicker
                className="w-100"
                value={tp.next_appointment ? dayjs(tp.next_appointment) : null}
                onChange={(date) => set('next_appointment', date ? date.format('YYYY-MM-DD') : null)}
                format="YYYY-MM-DD"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Próximos Laboratorios</label>
              <DatePicker
                className="w-100"
                value={tp.next_labs ? dayjs(tp.next_labs) : null}
                onChange={(date) => set('next_labs', date ? date.format('YYYY-MM-DD') : null)}
                format="YYYY-MM-DD"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">Notas del Plan</label>
              <textarea
                className="form-control"
                rows={3}
                value={tp.plan_notes}
                onChange={(e) => set('plan_notes', e.target.value)}
                placeholder="Describa el plan de tratamiento detallado..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TreatmentPlan;
